<div class="chat-content">
  <button class="backBtn" mat-button (click)="goToDashboard()"><mat-icon slot="start">arrow_back</mat-icon>Zpět</button>
</div>
<div class="content">
  <div class="header">
    <h1 class="page-header"><mat-icon slot="start" class="icon-mic">mic</mat-icon> Zkouška zvuku a mikrofonu</h1>
  </div>
  @if (loading) {
    <div style="width: 100%;text-align: center;">
      <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
    </div>
  }
  @else {
    <div class="content-data">
      <p>V jakém rodě Vás máme oslovovat?</p>
      <mat-button-toggle-group #group="matButtonToggleGroup" name="fontStyle" [(ngModel)]="gender" (change)="changeGender()" aria-label="Oslovení">
        <mat-button-toggle value="1">V mužském</mat-button-toggle>
        <mat-button-toggle value="2">V ženském</mat-button-toggle>
      </mat-button-toggle-group>
      <br>
    </div>
  }
</div>
<div class="chat-content">
  <div class="chat-inner-content">
    @if ((agentText || agentSpeaking)) {
      <div class="speech-bubble {{agentSpeaking && !thinking ? 'speech-bubble-active' : 'speech-bubble-inactive'}}">
        <p>
          {{agentText}}
          @if (agentSpeaking && !thinking) {
            <span class="typing-dots">
                <span>.</span><span>.</span><span>.</span>
              </span>
          }
        </p>
      </div>
    }
    <div class="img-agent">
      <div class="waveform-wrapper" style="{{!checkInProgress ? 'display:none;' : 'display:block;'}} {{agentSpeaking && !thinking ? 'border: 1px solid #fce0c8;' : 'border: 1px solid lightgray;'}}">
        <canvas #waveformCanvas></canvas>
      </div>
      @if (!checkInProgress) {
        @if (!micReady && !loading) {
          Mikrofon není připojený
        }
        @else {
          @if (checkComplete) {
            <div class="startDiv done-div">
              <strong><mat-icon slot="start" class="checkIcon">check_small</mat-icon>&nbsp;&nbsp;Test proběhl v pořádku</strong>
              <div class="btnLine">
                <button mat-button (click)="goToDashboard()" class="startBtn">Zpět do hlavního menu</button>
              </div>
            </div>
          } @else if (checkFailed){
            <div class="startDiv error-div">
              <strong>Chyba, zkuste to znovu</strong>
              <ul class="error-text">
                <li>Omezte okolní hluk. Optimální je tiché prostředí.</li>
                <li>Ujistěte se, že jste prohlížeči povolili přístup k mikrofonu.</li>
                <li>Dbejte na jasnou výslovnost a srozumitelnost.</li>
              </ul>

              <div class="btnLine">
                <button mat-button (click)="startCheck()" class="startBtn">Opakovat test</button>
              </div>
            </div>
          }
          @else {
            <div class="startDiv">
              <div class="startDiv instruction-div">
                <strong>Instrukce pro hlasový test:</strong>
                <ul class="instruction-text">
                  <li>Omezte okolní hluk. Optimální je tiché prostředí.</li>
                  <li>Zapněte si reproduktory</li>
                  <li>Pokud vás k prohlížeč vyzve, povolte mu přístup k mikrofonu.</li>
                  <li>Dbejte na jasnou výslovnost a srozumitelnost.</li>
                </ul>
                <strong>Postup testu je následující:</strong>
                <ul class="instruction-text">
                  <li><strong>Spuštění:</strong> Přehrajeme a zobrazíme vám větu, kterou budete testovat.</li>
                  <li><strong>Nahrávání:</strong> Jakmile se rozbliká ikona mikrofonu, začněte co nejsrozumitelněji číst zobrazený text.</li>
                  <li><strong>Ukončení nahrávání:</strong> Nahrávání se automaticky zastaví po 4 sekundách ticha.</li>
                  <li><strong>Zpracování:</strong> Vyčkejte na zobrazení přepisu vaší řeči.</li>
                  <li><strong>Oprava:</strong> V případě, že bude přepis nesrozumitelný, budete vyzváni k opravě testu.</li>
                  <li><strong>Výsledek:</strong> Pokud test proběhne úspěšně, zobrazí se zpráva o úspěšném dokončení a tlačítko pro návrat do menu.</li>
                </ul>
                <div class="btnLine">
                  <button mat-button (click)="startCheck()" class="startBtn">Začít</button>
                </div>
            </div>
            </div>
          }
        }
      }
    </div>
    @if ((respText || checkInProgress || checkComplete || checkFailed)) {
      <div class="chat-content-answer">
          <div class="speech-bubble {{(agentSpeaking || thinking) || !checkInProgress ? 'speech-bubble-inactive' : 'speech-bubble-active'}}">
            <p>
              {{respText}}
              @if (!agentSpeaking && !thinking && checkInProgress) {
                <span class="typing-dots">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
              }
            </p>
          </div>
      </div>
      <div class="controls">
        <button mat-fab color="primary" class="btnMic" disableRipple [disabled]="agentSpeaking || !checkInProgress" class="{{agentSpeaking || !checkInProgress ? '' : 'pulsate'}}">

          @if (agentSpeaking) {
            <ng-container><mat-icon>mic_off</mat-icon></ng-container>
          } @else {
            <ng-container><mat-icon>mic</mat-icon></ng-container>
          }
        </button><br>
        @if (!thinking && checkInProgress) {
          <p><strong>{{instructions}}</strong></p>
        }
      </div>
    }
  </div>
</div>
